import { useOrganizationPlan } from "@/shared/hooks/useOrganizationFeatures";
import { useUserData, useOrganizationData } from "@/shared/hooks/useSidebarData";

export const useSidebarReadyState = () => {
  const { userOrganizationId, organizationNameFromRedux } = useUserData();
  const { isLoading: isOrgLoading } = useOrganizationData(
    userOrganizationId,
    organizationNameFromRedux,
  );
  const { isLoading: isPlanLoading } = useOrganizationPlan();

  return { isSidebarReady: !isOrgLoading && !isPlanLoading };
};
